<template>
  <div class="d-flex flex-column flex-root">
    <div
        class="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
        :style="{
        backgroundImage: `url(${backgroundImage})`,
      }"
    >
      <!-- begin:: Content -->
      <div class="d-flex flex-column flex-row-fluid text-center">
        <h1
            class="error-title font-weight-boldest text-white mb-12"
            style="margin-top: 12rem;"
        >
          {{ $t('404.title') }}
        </h1>
        <div class="display-4 font-weight-bold text-white">
          {{ $t('404.text') }}
        </div>
        <router-link to="/dashboard">
          <div class="my-2">
            <v-btn color="error" dark>{{ $t('common.homepage') }}</v-btn>
          </div>
        </router-link>
      </div>
      <!-- end:: Content -->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/sass/pages/error/error-6.scss";
</style>

<script>
export default {
  name: "Error-6",
  computed: {
    backgroundImage() {
      return process.env.BASE_URL + "media/error/bg6.jpg";
    },
  },
};
</script>
